import api from "../api";

const state = {
  sending: false,
  response: [],
  loading: false
};

const getters = {
  getSending: state => state.sending,
  getResponse: state => state.response
};

const mutations = {
  TOGGLE_SENDING: (state, payload) => (state.sending = payload),
  SET_RESPONSE: (state, payload) => (state.response = payload)
};

const actions = {
  send: async ({ commit }, payload) => {
    commit("TOGGLE_SENDING", true);
    let res = await api("post", payload.url, payload.data);
    commit("TOGGLE_SENDING", false);
    commit("SET_RESPONSE", res);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
